import { environment } from '@env/environment';
import { AuthConfig } from 'angular-oauth2-oidc';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.authCodeFlowIssuer,
  redirectUri: `${window.location.origin}`,
  clientId: 'spa',
  scope: 'openid profile email offline_access nDziekanatApi',
  preserveRequestedRoute: true,
  responseType: 'code',
  requireHttps: environment.requireHttps,
  sessionChecksEnabled: true,
  clearHashAfterLogin: true,
  showDebugInformation: false,
};
